<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-form
            ref="riskAnalysisReportForm"
        >
          <h3 class="mb-3" v-if="displayMainTitle">
            <v-icon v-if="is_corona_variant" style="padding-bottom: 6px;margin-right: 10px;color:red;">mdi-biohazard
            </v-icon>
            {{ (this.is_corona_variant) ? $vuetify.lang.t('$vuetify.risk_analysis.title.corona') : $vuetify.lang.t('$vuetify.risk_analysis.title.risk_default') }}
          </h3>
          <p class="pt-3" style="color: #999999;font-size: 13px;" v-if="getSubTitle !== false">{{ getSubTitle }}</p>
          <v-row align="center">
            <v-col cols="10">
              <v-select
                  v-model="risk_gravity"
                  :items="gravity_list"
                  item-value="value"
                  item-text="display_value"
                  :label="(this.is_corona_variant)? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.distance.label') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.gravity.label')"
                  :menu-props="{ contentClass : 'risk-dropdown-item'}"
                  @change="calculate_result()"
                  :disabled="formDisabled"
              ></v-select>
            </v-col>
            <v-col cols="2" class="text-center">
              <b>{{ risk_gravity }}</b>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col cols="10">
              <v-select
                  v-model="risk_probability"
                  :items="probability_list"
                  item-value="value"
                  item-text="display_value"
                  :label="(this.is_corona_variant)? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.probability.label') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.probability.label')"
                  :menu-props="{ contentClass : 'risk-dropdown-item'}"
                  @change="calculate_result()"
                  :disabled="formDisabled"
              ></v-select>
            </v-col>
            <v-col cols="2" class="text-center">
              <b>{{ risk_probability }}</b>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="10">
              <v-select
                  v-model="risk_exposure"
                  :items="exposure_list"
                  item-value="value"
                  item-text="display_value"
                  :label="(this.is_corona_variant)? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.exposure.label') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.exposure.label')"
                  :menu-props="{ contentClass : 'risk-dropdown-item'}"
                  @change="calculate_result()"
                  :disabled="formDisabled"
              ></v-select>
            </v-col>
            <v-col cols="2" class="text-center">
              <b>{{ risk_exposure }}</b>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="12">
              <v-alert :icon="false" :color="kinneyBackgroundColor" class="mt-3 mb-3 pt-0 pb-0">
                <v-row>
                  <v-col cols="10">
                    <p class=" mb-0"><b>{{ kinneyCodeMessage }}</b></p>
                  </v-col>
                  <v-col cols="2" style="justify-content: center;align-items: center;display: flex;">
                    <p class="text-right mb-0"><b>{{ risk_index }}</b></p>
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <p>{{ supportive_text }}</p>
            </v-col>
          </v-row>
          <v-row v-if="this.show_send_report_form" align="center">
            <v-col cols="12">
              <p class="text-center">{{ this.$vuetify.lang.t('$vuetify.risk_analysis.report_title') }}</p>
              <v-textarea
                  v-model="report_input"
                  no-resize
                  rows="6"
                  ref="inputRef"
                  :label="$vuetify.lang.t('$vuetify.risk_analysis.placeholder_report')"
                  autofocus
                  :disabled="formDisabled"
              ></v-textarea>
              <div class="text-center text-md-left">
                <v-btn class="white--text" color="primary" :disabled="isFilled" @click="doLocationCheck">
                  {{ $vuetify.lang.t('$vuetify.global.confirmAndSend') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>

    <locationPopup :is-visible="showPrivateLocationPopup" @checkComplete="save"></locationPopup>
  </v-container>
</template>
<script>
import appSettings from "../../../mixins/config/appSettings"
import PrivateLocationCheckComponent from '../global/privateLocationChecker/PrivateLocationCheckComponent';
import urlParamsConstructor from '../../../mixins/config/urlParamsConstructor';
import {ENTRY_DATA_KEY, LMRADataObjectHelper} from "@/api/repository/helpers/LMRADataObjectHelper";
import lmraDataRepositoryApi from "@/api/repository/lmraDataRepositoryApi";
import sendingLmraDataHelper from "@/helpers/sendingLmraDataHelper";


export default {
  data: () => {
    return {
      gravity_list: [],
      probability_list: [],
      exposure_list: [],
      risk_gravity: null,
      risk_probability: null,
      risk_exposure: null,
      risk_index: 0,
      kinneyCodeMessage: '',
      kinneyBackgroundColor: '#50DE65',
      show_send_report_form: false,
      report_has_been_sent: false,
      report_input: '',
      report_min_length: 4,
      formDisabled: false,
      showPrivateLocationPopup: false,
      is_corona_variant: false,
      supportive_text: ''
    }
  },
  components: {
    locationPopup: PrivateLocationCheckComponent
  },
  methods: {
    doLocationCheck() {
      this.showPrivateLocationPopup = true;
    },
    create_gravity_list() {
      this.gravity_list = [
        {
          value: 1,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.distance.distance_01') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.gravity.gravity_01')
        },
        {
          value: 2,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.distance.distance_02') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.gravity.gravity_02')
        },
        {
          value: 7,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.distance.distance_07') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.gravity.gravity_07')
        },
        {
          value: 15,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.distance.distance_15') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.gravity.gravity_15')
        },
        {
          value: 40,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.distance.distance_40') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.gravity.gravity_40')
        }
      ]

      if (this.is_corona_variant) {
        let obj = {
          value: 100,
          display_value: this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.distance.distance_100')
        }
        this.gravity_list.push(obj);
      }

    },
    create_probability_list() {
      this.probability_list = [
        {
          value: 0.1,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.probability.probability_0_1') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.probability.probability_0_1')
        },
        {
          value: 0.2,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.probability.probability_0_2') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.probability.probability_0_2')
        },
        {
          value: 0.5,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.probability.probability_0_5') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.probability.probability_0_5')
        },
        {
          value: 1,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.probability.probability_01') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.probability.probability_01')
        },
        {
          value: 3,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.probability.probability_03') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.probability.probability_03')
        },
        {
          value: 6,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.probability.probability_06') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.probability.probability_06')
        },
        {
          value: 10,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.probability.probability_10') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.probability.probability_10')
        }
      ]
    },
    create_exposure_list() {
      this.exposure_list = [
        {
          value: 0.5,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.exposure.exposure_0_5') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.exposure.exposure_0_5')
        },
        {
          value: 1,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.exposure.exposure_01') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.exposure.exposure_01')
        },
        {
          value: 2,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.exposure.exposure_02') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.exposure.exposure_02')
        },
        {
          value: 3,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.exposure.exposure_03') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.exposure.exposure_03')
        },
        {
          value: 6,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.exposure.exposure_06') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.exposure.exposure_06')
        },
        {
          value: 10,
          display_value: (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.lists.corona.exposure.exposure_10') : this.$vuetify.lang.t('$vuetify.risk_analysis.lists.risk_default.exposure.exposure_10')
        }
      ]
    },
    calculate_result() {
      //console.log('CHANGED');
      if (this.risk_gravity !== null &&
          this.risk_probability !== null &&
          this.risk_exposure !== null) {

        let riskFloat = (parseFloat(this.risk_gravity) * parseFloat(this.risk_probability)) * parseFloat(this.risk_exposure);
        this.risk_index = Math.round(riskFloat);

        this.display_risk_result();
      }
    },
    display_risk_result() {
      if (this.appSettings.canSendRiskAnalysisReports) {
        if (this.risk_index >= this.appSettings.riskAnalysisReportThreshold) {
          this.show_send_report_form = true;
        } else {
          this.show_send_report_form = false;
        }
      }
      if (this.risk_index > 400) {
        this.kinneyBackgroundColor = "#fe0000";
        this.kinneyCodeMessage = (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.results.corona.kinneyCode5') : this.$vuetify.lang.t('$vuetify.risk_analysis.results.risk_default.kinneyCode5')
        this.supportive_text = (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.supportive_texts.corona.supportiveText5') : this.$vuetify.lang.t('$vuetify.risk_analysis.supportive_texts.risk_default.supportiveText5')
      } else if (this.risk_index > 200) {
        this.kinneyBackgroundColor = "#fe9900";
        this.kinneyCodeMessage = (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.results.corona.kinneyCode4') : this.$vuetify.lang.t('$vuetify.risk_analysis.results.risk_default.kinneyCode4')
        this.supportive_text = (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.supportive_texts.corona.supportiveText4') : this.$vuetify.lang.t('$vuetify.risk_analysis.supportive_texts.risk_default.supportiveText4')
      } else if (this.risk_index > 70) {
        this.kinneyBackgroundColor = "#fecc00";
        this.kinneyCodeMessage = (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.results.corona.kinneyCode3') : this.$vuetify.lang.t('$vuetify.risk_analysis.results.risk_default.kinneyCode3')
        this.supportive_text = (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.supportive_texts.corona.supportiveText3') : this.$vuetify.lang.t('$vuetify.risk_analysis.supportive_texts.risk_default.supportiveText3')
      } else if (this.risk_index > 20) {
        this.kinneyBackgroundColor = "#fefe00";
        this.kinneyCodeMessage = (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.results.corona.kinneyCode2') : this.$vuetify.lang.t('$vuetify.risk_analysis.results.risk_default.kinneyCode2')
        this.supportive_text = (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.supportive_texts.corona.supportiveText2') : this.$vuetify.lang.t('$vuetify.risk_analysis.supportive_texts.risk_default.supportiveText2')
      } else {
        this.kinneyBackgroundColor = "#50DE65";
        this.kinneyCodeMessage = (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.results.corona.kinneyCode1') : this.$vuetify.lang.t('$vuetify.risk_analysis.results.risk_default.kinneyCode1')
        this.supportive_text = (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.supportive_texts.corona.supportiveText1') : this.$vuetify.lang.t('$vuetify.risk_analysis.supportive_texts.risk_default.supportiveText1')
      }
    },
    async save() {
      this.formDisabled = true;
      this.showPrivateLocationPopup = false;
      let dataObject = await LMRADataObjectHelper.buildBaseLmraDataObject();
      dataObject[ENTRY_DATA_KEY]['severity'] = parseFloat(this.risk_gravity)
      dataObject[ENTRY_DATA_KEY]['probability'] = parseFloat(this.risk_probability)
      dataObject[ENTRY_DATA_KEY]['exposure'] = parseFloat(this.risk_exposure)
      dataObject[ENTRY_DATA_KEY]['risk_index'] = this.risk_index;
      dataObject[ENTRY_DATA_KEY]['description'] = this.report_input.trim();
      dataObject[ENTRY_DATA_KEY]['analysis_type'] = (this.is_corona_variant)? 'CORONA-ANALYSIS' : 'DEFAULT';

      /* START SENDING PART */
      //START SENDING PART
      await lmraDataRepositoryApi.reportRiskAnalysis(dataObject).then(
          response => {
            window.console.log('RESPONSE : ')
            window.console.log(response);
            let message = this.$vuetify.lang.t('$vuetify.global.post_success');
            if (response.data.message !== undefined) {
              message = response.data.message;
            }
            this.report_has_been_sent = true;
            sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(message)
            this.$router.replace('/');
          }
      ).catch(error => {
        window.console.log('ERROR');
        window.console.log(error);
        sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(this.$vuetify.lang.t('$vuetify.errors.data_save_failed') + ' err: ' + error.message);
        this.formDisabled = false;
      });
      /* END SENDING PART */
    },
    doCanLeaveCheck() {
      //console.log('--- CAN LEAVE CHECK');
      if (this.show_send_report_form) {
        if (!this.report_has_been_sent) {
          return false;
        }
      }
      //console.log('CAN LEAVE');
      return true
    },
    getLeaveWarningTitle() {
      return (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.leave_warning.corona.title') : this.$vuetify.lang.t('$vuetify.risk_analysis.leave_warning.risk_default.title')
    },
    getLeaveWarningBody() {
      return (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.leave_warning.corona.body') : this.$vuetify.lang.t('$vuetify.risk_analysis.leave_warning.risk_default.body')
    }
  },
  computed: {
    isFilled: function () {
      let trimmed = this.report_input.trim()
      if (trimmed.length >= this.report_min_length && !this.formDisabled) {
        return false;
      } else {
        return true
      }
    },
    getSubTitle() {
      let subTitle = (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.title.corona_sub_title') : this.$vuetify.lang.t('$vuetify.risk_analysis.title.risk_default_sub_title');
      if (subTitle.length > 0 && subTitle !== '$vuetify.risk_analysis.title.corona.corona_sub_title' && subTitle !== '$vuetify.risk_analysis.title.risk_default_sub_title') {
        return subTitle
      }
      return false;
    },
    displayMainTitle() {
      if (this.is_corona_variant && process.env.VUE_APP_CORONA_RISK_ANALYSIS_HIDES_TITLE) {
        return false;
      }
      return true
    }
  },
  mixins: [appSettings,urlParamsConstructor],
  created() {
    if (this.$route.name === 'corona_analysis') {
      this.is_corona_variant = true;
    }
    this.create_gravity_list();
    this.create_probability_list();
    this.create_exposure_list();
    this.kinneyCodeMessage = (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.results.corona.kinneyCode1') : this.$vuetify.lang.t('$vuetify.risk_analysis.results.risk_default.kinneyCode1');
    this.supportive_text = (this.is_corona_variant) ? this.$vuetify.lang.t('$vuetify.risk_analysis.supportive_texts.corona.supportiveText1') : this.$vuetify.lang.t('$vuetify.risk_analysis.supportive_texts.risk_default.supportiveText1')
  }
}
</script>
<style>
.risk-dropdown-item .v-list-item__title {
  white-space: normal !important;
}
</style>
